import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { LoadingButton } from '@mui/lab';

import { MaterialIcon } from '@components';
import { useGlobalNotifier } from '@hooks';
import { routes } from '@routes';

import { useReassessStandingAccessReport } from '@StandingAccess/services/standingAccessMutations';
import { AssessmentReportStatus } from '@StandingAccess/types';
import { Stack } from '@mui/material';
import AssessmentStatus from '@StandingAccess/components/AssessmentStatus';
import { StandingAccessReportAppModel } from '@api';

interface AssessmentReportReassessProps {
  report: StandingAccessReportAppModel;
}

export default function AssessmentReportReassess({ report }: AssessmentReportReassessProps) {
  const isDisabled =
    report.status.status === AssessmentReportStatus.InProgress ||
    report.status.status === AssessmentReportStatus.ReAssess ||
    report.status.status === AssessmentReportStatus.Error;

  return (
    <Stack direction="row" alignItems="center" spacing={2}>
      <AssessmentStatus reportStatus={report.status} />
      <AssessmentReportReassessButton reportId={report.id} isDisabled={isDisabled} />
    </Stack>
  );
}

export function AssessmentReportReassessButton({ reportId, isDisabled }: { reportId: string; isDisabled?: boolean }) {
  const { notifySuccess } = useGlobalNotifier();
  const navigate = useNavigate();
  const { reassessStandingAccessReport, isLoading, isSuccess } = useReassessStandingAccessReport();

  useEffect(() => {
    if (isSuccess) {
      navigate(routes.StandingAccessReports.path);
      notifySuccess('Request for report reassessment sent successfully');
    }
  }, [isSuccess, navigate, notifySuccess]);

  return (
    <LoadingButton
      variant="contained"
      size="small"
      startIcon={<MaterialIcon symbol="sync" weight={700} />}
      onClick={() => reassessStandingAccessReport({ reportId })}
      loading={isLoading}
      disabled={isDisabled}
    >
      Reassess
    </LoadingButton>
  );
}
